import React from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { Toaster } from 'react-hot-toast';

// Context Providers
import { AuthProvider } from './contexts/AuthContext';
import { DebugProvider } from './contexts/DebugContext';

// Theme
import muiPalette from './mui-palette';

const theme = createTheme({
  palette: muiPalette,
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
  },
});

interface AppProps {
  children: React.ReactNode;
}

const App: React.FC<AppProps> = ({ children }) => {
  return (
    <DebugProvider>
      <AuthProvider>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Toaster position="top-right" />
          {children}
        </ThemeProvider>
      </AuthProvider>
    </DebugProvider>
  );
};

export default App; 